// extracted by mini-css-extract-plugin
export default {"chapters":"styles_chapters__WqsG6"};